module.exports = __webpack_public_path__ + "media/images/countrysquared/py-d9154fa5f194f26f7f60be7bdc012400.svg";